module.exports = __webpack_public_path__ + "static/media/icono5.e01a19bf.png";